import React, { useContext, useState, useEffect } from "react";
import { MusicContext } from "../Context/MusicContext";
import Image29 from "../Images/Image29.png";
import Image29_29 from "../Images/Image29-29.png";
import Star from "../Icons/Star.png";
import "../Styles/Page.css";

function Page29(){
  const { currentTimeRef, language, currentPage } = useContext(MusicContext);
  const [flipped, setFlipped] = useState(true);

  const [, forceUpdate] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      forceUpdate((n) => n + 1);
    }, 200); 
    return () => clearInterval(interval);
  }, []);

   function stop(e){
    e.stopPropagation();
    e.preventDefault()
    if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation){
      e.nativeEvent.stopImmediatePropagation();
    }
  };

  function handleToggle(e){
    e.stopPropagation();
    setFlipped((prev) => !prev);
  };

     const transcripts = {
        en: {
      dropCap: "A ",
      dropCapText: " LOW HUM",
      lines: [
    { text: "filled the air and Thingo began to glow.", start: 0, end: 3.3 },
    { text: "Its leaves stretched upward and released a soft chime, like tiny bells in the wind.", start: 3.4, end: 8.1 },
    { text: "The glow rippled through the soil and spread across the garden,", start: 8.2, end: 11.7 },
    { text: "up the hill, and down the streets of Dumakude.", start: 11.8, end: 15.5 },
  ]
},
       zu: {
    dropCap: "K",
    dropCapText: "UBE NOKUTHULA",
    lines: [
    { text: "emoyeni bese uThingo waqala ukukhanya.", start: 0, end: 5 },
    { text: "Amaqabunga akhe akhuphukela phezulu, akhipha iculo ezolile, ezwakala njengezinsimbi ezincane.", start: 5.1, end: 12.5 },
    { text: "Ukukhanya kwagcwala enhlabathini kwenyuka emagqumeni nemigwaqo yaseDumakude.", start: 12.6, end: 19.3 },
  ]
}
};
      const { dropCap, dropCapText, lines } = transcripts[language];
      const currentTime = currentTimeRef.current;

  return(
    <section className="page">
    <section className="drop-cap-container">
      <section className="drop-cap">{dropCap}</section>
      <section className="drop-cap-text">{dropCapText}</section>
    </section>

      <p className="page-chapter">
        {lines.map((line, i) => {
        const isActive = currentPage === 29 && currentTime >= line.start && currentTime <= line.end;
          return(
            <span key={i} className={isActive ? "highlight" : ""}>
              {line.text + " "}
            </span>
          );
        })}
      </p>

   <section className="image-wrapper" onClick={stop} onPointerDown={stop} onMouseDown={stop} onTouchStart={stop}>
     {flipped ? (
          <img src={Image29} alt="Page 29" className="page-image-29" />
        ) : (
          <img src={Image29_29} alt="Page 29" className="page-image-29-29" />
        )}

      <img src={Star} alt="Star" className="star-indicator" onClick={handleToggle} />
      </section>

      <section className="odd">29</section>
    </section>
  );
}

export default Page29;